import React, { useState } from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Grid, Button } from "@material-ui/core"
import { css } from '@emotion/core'
import BlogPreview from '../components/BlogPreview'
import PageHeader from '../components/Blog/pageHeader'
import Breadcrumbs from '../components/MainComponents/Breadcrumbs'
import queryString from "query-string";

const BlogCategoryIndex = ({ data, title, location }) => {
  const { page } = queryString.parse(location.search);
  const [pageCount, setPageCount] = useState(parseInt(page) || 1)
  const pageCountTotal = Math.ceil(data.edges.length / 6);
  const blogPostSizes = {
    sm: 6,
    md: 4,
  }
  return (
  <Layout
    PageHeader={() => <PageHeader pageTitle={title ? title : 'Blog'} />}
  >
    <SEO 
      title={title ? title : 'Blog'}
      url={location.pathname}
    />
    <Breadcrumbs url={location.pathname} />
    <Grid
      container
      spacing={1}
    >
      {data.edges.slice(0, 6 * pageCount).map(({ node }, index) => {
        return (
          <BlogPreview
            imgData={
              node.featured_media.localFile.childImageSharp ?
                node.featured_media.localFile.childImageSharp.fluid :
                data.file.childImageSharp.fluid
            }
            title={node.title}
            link={node.slug}
            excerpt={node.excerpt}
            index={index}
            sizes={blogPostSizes}
          />
        )
      })}
    </Grid>
    {pageCount < pageCountTotal &&
      <div
        css={css`
              width: 100%;
              text-align: center;
              margin-top: 20px;
            `}
      >
        <Button variant="outlined" onClick={() => {
          setPageCount(pageCount + 1)
          window.history.replaceState(null, null, `?page=${pageCount + 1}`);
        }}>More Posts</Button>
      </div>
    }
  </Layout>
  )
}

export default BlogCategoryIndex